/* Informational quotes only. Native cart and checkout remain in control. */
(() => {
  'use strict';
  const configNode = document.getElementById('JetLifeShippingConfig');
  if (!configNode || window.jetLifeShippingLoaded) return;
  window.jetLifeShippingLoaded = true;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const m = config.messages;
  const root = window.Shopify?.routes?.root || '/';
  const url = path => root + path;
  const fingerprint = c => JSON.stringify([c.currency, c.total_price, c.items.map(i => [i.key, i.quantity, i.requires_shipping])]);
  const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency }).format(value);
  const module = document.querySelector('[data-jlse-estimator]');
  let invalidate = () => {};
  if (module) {
    const anchorSpacing = () => {
      const header = document.querySelector('.site-header');
      module.style.setProperty('--jlse-scroll-offset', `${Math.ceil(header?.getBoundingClientRect().height || 180) + 24}px`);
    };
    anchorSpacing();
    window.addEventListener('resize', anchorSpacing);
    if (location.hash === '#ShippingEstimate') requestAnimationFrame(() => module.scrollIntoView({block:'start'}));
    const get = sel => module.querySelector(`[data-jlse-${sel}]`);
    const country = get('country'), province = get('province'), postcode = get('postcode');
    const button = get('estimate'), status = get('status'), results = get('results'), list = get('rates'), more = get('more');
    let sequence = 0, startedAt = 0, quotedCart, pendingCart, quotedRates = [], shown = false, expanded = false, busy = false;
    const say = (text, error = false) => { status.textContent = text; status.dataset.error = String(error); };
    const finish = () => { busy = false; button.disabled = false; module.removeAttribute('aria-busy'); };
    invalidate = (message = m.changed) => {
      // Logical cancellation avoids aborted-fetch errors in third-party tracking wrappers.
      sequence++; finish();
      const had = shown || quotedCart;
      shown = false; quotedCart = null; pendingCart = null; quotedRates = []; results.hidden = true; list.replaceChildren(); more.hidden = true;
      say(had ? message : '');
    };
    const provinces = () => {
      let values = [];
      try { values = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) {}
      province.replaceChildren(new Option(m.choose, ''));
      values.forEach(([value,label]) => province.add(new Option(label, value)));
      get('province-wrap').hidden = values.length === 0;
      province.disabled = values.length === 0;
    };
    if ([...country.options].some(o => o.value === config.defaultCountry)) country.value = config.defaultCountry;
    provinces();
    country.addEventListener('change', () => { provinces(); invalidate(); });
    province.addEventListener('change', () => invalidate());
    postcode.addEventListener('input', () => { postcode.removeAttribute('aria-invalid'); invalidate(); });
    postcode.addEventListener('keydown', e => { if(e.key === 'Enter') { e.preventDefault(); button.click(); } });
    module.querySelectorAll('[data-jlse-tab]').forEach(tab => tab.addEventListener('click', () => {
      const ship = tab.dataset.jlseTab === 'ship';
      module.querySelectorAll('[data-jlse-tab]').forEach(t => t.setAttribute('aria-pressed', String(t === tab)));
      get('ship').hidden = !ship; get('pickup').hidden = ship;
      if (!ship) invalidate('');
    }));
    const draw = () => {
      list.replaceChildren();
      quotedRates.forEach((r,index) => {
        const li = document.createElement('li');
        if (index >= 2 && !expanded) li.hidden = true;
        const name = document.createElement('span'); name.textContent = r.name;
        if (index === 0) { const label = document.createElement('small'); label.textContent = m.lowest; name.append(label); }
        const price = document.createElement('strong'); price.textContent = money(r.amount, quotedCart.currency);
        li.append(name, price); list.append(li);
      });
      more.hidden = quotedRates.length <= 2;
      more.textContent = expanded ? m.less : m.more;
      more.setAttribute('aria-expanded', String(expanded));
      const label = document.createElement('span'); label.textContent = m.total;
      const total = document.createElement('strong'); total.textContent = money(quotedCart.total_price / 100 + quotedRates[0].amount, quotedCart.currency);
      get('total').replaceChildren(label,total);
      results.hidden = false;
    };
    more.addEventListener('click', () => { if (!quotedCart) return; expanded = !expanded; draw(); });
    const request = async (path, options = {}) => {
      let timer;
      const remaining = Math.min(15000, 45000 - (Date.now() - startedAt));
      if (remaining <= 0) throw new Error(m.error);
      try {
        return await Promise.race([
          (async () => {
            const response = await fetch(url(path), { credentials:'same-origin', ...options });
            const data = await response.json();
            if (!response.ok) {
              const details = Object.values(data || {}).flat().filter(v => typeof v === 'string').join(' ');
              throw new Error(details || m.error);
            }
            return data;
          })(),
          new Promise((_,reject) => { timer = setTimeout(() => reject(new Error(m.error)),remaining); })
        ]);
      } finally { clearTimeout(timer); }
    };
    button.addEventListener('click', async () => {
      if (busy) return;
      const needsProvince = !province.disabled;
      if (!country.value || (needsProvince && !province.value) || !postcode.value.trim()) {
        say(m.required, true);
        if (!postcode.value.trim()) postcode.setAttribute('aria-invalid','true');
        (!country.value ? country : needsProvince && !province.value ? province : postcode).focus();
        return;
      }
      invalidate(''); shown = true;
      const token = sequence; startedAt = Date.now(); busy = true; button.disabled = true; module.setAttribute('aria-busy','true'); say(m.loading);
      try {
        const cart = await request('cart.js');
        if (sequence !== token) return;
        pendingCart = cart;
        if (!cart.item_count) throw new Error(m.empty);
        if (!cart.items.some(i => i.requires_shipping)) throw new Error(m.digital);
        const query = new URLSearchParams({
          'shipping_address[country]':country.value,
          'shipping_address[province]':needsProvince ? province.value : '',
          'shipping_address[zip]':postcode.value.trim()
        }).toString();
        await request(`cart/prepare_shipping_rates.json?${query}`, {method:'POST'});
        let data = null;
        for (let attempt = 0; attempt < 18; attempt++) {
          if (sequence !== token) return;
          data = await request(`cart/async_shipping_rates.json?${query}`);
          if (data !== null) break;
          await new Promise(resolve => setTimeout(resolve, Math.min(800 + attempt * 150,2000)));
        }
        if (sequence !== token) return;
        if (data === null) throw new Error(m.error);
        const latest = await request('cart.js');
        if (fingerprint(latest) !== fingerprint(cart)) { invalidate(); return; }
        const rates = (data.shipping_rates || []).filter(r => r.price !== '' && Number.isFinite(Number(r.price)) && Number(r.price) >= 0 && (!r.currency || r.currency === cart.currency)).map(r => ({name:String(r.name),amount:Number(r.price)})).sort((a,b) => a.amount-b.amount);
        if (!rates.length) throw new Error(m.no_rates);
        if (sequence !== token) return;
        quotedCart = cart; pendingCart = null; quotedRates = rates; expanded = false; shown = true;
        say(`${m.ready} ${[postcode.value.trim(),needsProvince && province.value,country.value].filter(Boolean).join(', ')}`);
        draw();
      } catch (error) {
        if (sequence === token && error.name !== 'AbortError') { say(error.message || m.error,true); results.hidden = true; }
      } finally { if (sequence === token) { pendingCart = null; finish(); } }
    });
    const verify = async () => {
      const reference = quotedCart || pendingCart, token = sequence;
      if (!reference) return;
      try {
        const cart = await fetch(url('cart.js'),{credentials:'same-origin'}).then(r=>r.json());
        if (sequence === token && fingerprint(cart)!==fingerprint(reference)) invalidate();
      } catch (_) { if (sequence === token) invalidate(); }
    };
    document.getElementById('CartPageForm')?.addEventListener('change', e => {
      if (!module.contains(e.target) && (e.target.name === 'updates[]' || e.target.closest('[data-products]'))) invalidate();
    });
    const products = document.querySelector('#CartPageForm [data-products]');
    if (products) new MutationObserver(verify).observe(products,{childList:true,subtree:true,characterData:true});
    document.addEventListener('visibilitychange', () => { if (!document.hidden) verify(); });
    window.addEventListener('focus',verify);
    ['cart:updated','cart:change','rebuy:cart.change'].forEach(event => document.addEventListener(event, verify));
  }
  if (!config.drawerLink) return;
  let rebuyObserver, scheduled = false;
  const linkDrawer = () => {
    scheduled = false;
    const flyout = document.querySelector('.rebuy-cart__flyout');
    const slot = flyout?.querySelector('[data-app-target="below_subtotal"]');
    if (!slot) return;
    let box = slot.querySelector('[data-jlse-rebuy]');
    if (!box) {
      box = document.createElement('div'); box.className = 'jlse-drawer'; box.dataset.jlseRebuy = '';
      const a = document.createElement('a'); a.href = config.cartUrl + '#ShippingEstimate'; a.textContent = config.drawerLabel;
      const p = document.createElement('p'); p.textContent = config.drawerCopy; box.append(a,p); slot.append(box);
    }
    const empty = !flyout.querySelector('.rebuy-cart__flyout-content.has-items');
    if (box.hidden !== empty) box.hidden = empty;
    if (!rebuyObserver) {
      rebuyObserver = new MutationObserver(schedule);
      rebuyObserver.observe(flyout,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
      discovery.disconnect();
    }
  };
  const schedule = () => { if (!scheduled) {scheduled = true; requestAnimationFrame(linkDrawer);} };
  const discovery = new MutationObserver(schedule);
  discovery.observe(document.body,{childList:true,subtree:true});
  ['rebuy:smartcart.init','rebuy:smartcart.ready','rebuy:smartcart.show','rebuy:cart.change'].forEach(e=>document.addEventListener(e,schedule));
  schedule();
})();
